import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  List,
  ListItem,
  Link,
  Paper,
  Button,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Drawer,
  ListItemText
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import logo0 from '../assets/logo0.png';

const FAQ = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const mobileMenu = (
    <Box sx={{ width: 250, bgcolor: '#000', height: '100%', color: 'white' }}>
      <List>
        {['Solutions', 'Pricing', 'AI', 'Questions', 'AIChat', 'Options'].map((text) => (
          <ListItem button key={text}>
            <ListItemText 
              primary={text} 
              sx={{ 
                '& .MuiListItemText-primary': { 
                  color: 'white',
                  fontSize: '14px'
                }
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
      {/* Mobile Menu Drawer */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
      >
        {mobileMenu}
      </Drawer>

      {/* Header */}
      <Box sx={{ 
        bgcolor: '#000000', 
        color: 'white',
        py: { xs: 1, md: 1 }
      }}>
        <Container maxWidth="xl">
          {/* Top Navigation */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: { xs: 1, md: 1 },
            flexWrap: { xs: 'wrap', md: 'nowrap' }
          }}>
            {/* Logo and Mobile Menu */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'space-between',
              width: { xs: '100%', md: 'auto' }
            }}>
              <img 
                src={logo0} 
                alt="Larrvaries" 
                style={{ 
                  height: '30px',
                  filter: 'brightness(0) invert(1)',
                  objectFit: 'contain'
                }} 
              />
              {isMobile && (
                <IconButton 
                  sx={{ color: 'white' }}
                  edge="end"
                  onClick={handleDrawerToggle}
                >
                  <MenuIcon />
                </IconButton>
              )}
            </Box>

            {/* Navigation Links and Buttons */}
            {!isMobile && (
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: { md: 1, lg: 2 },
                flexWrap: 'nowrap'
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  gap: { md: 1, lg: 2 }
                }}>
                  {['Solutions', 'Pricing', 'AI', 'Questions', 'AIChat', 'Options'].map((item) => (
                    <Typography
                      key={item}
                      sx={{
                        color: '#fff',
                        fontSize: { md: '12px', lg: '14px' },
                        cursor: 'pointer',
                        '&:hover': { color: '#ccc' },
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Box>
                
                <TextField
                  size="small"
                  placeholder="Suchen"
                  sx={{
                    width: { md: '150px', lg: '200px' },
                    backgroundColor: '#333',
                    '& .MuiOutlinedInput-root': {
                      color: 'white',
                      '& fieldset': { borderColor: 'transparent' }
                    }
                  }}
                />
                
                <Button
                  sx={{
                    color: '#fff',
                    textTransform: 'none',
                    borderRadius: 0,
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
                  }}
                >
                  Login
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: '#00873c',
                    color: '#fff',
                    textTransform: 'none',
                    borderRadius: 0,
                    '&:hover': { bgcolor: '#00762f' }
                  }}
                >
                  Join now
                </Button>
              </Box>
            )}
          </Box>

          {/* Search Bar */}
          <Box sx={{ 
            display: 'flex', 
            gap: 1,
            alignItems: 'center',
            flexWrap: { xs: 'wrap', md: 'nowrap' }
          }}>
            <TextField
              fullWidth
              placeholder="Find your desired domain with AI search"
              size="small"
              sx={{
                bgcolor: '#fff',
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  '& fieldset': { borderColor: 'transparent' }
                }
              }}
            />
            <Box sx={{ 
              display: 'flex', 
              gap: 0.5,
              width: { xs: '100%', md: 'auto' },
              mt: { xs: 1, md: 0 }
            }}>
              <Button
                sx={{
                  bgcolor: '#333',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: 0,
                  flex: { xs: 1, md: 'none' },
                  '&:hover': { bgcolor: '#444' }
                }}
              >
                Scan
              </Button>
              <Select
                value="de"
                size="small"
                sx={{
                  bgcolor: '#fff',
                  width: { xs: '60px', md: '70px' },
                  borderRadius: 0,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent'
                  }
                }}
              >
                <MenuItem value="de">de</MenuItem>
              </Select>
              <Select
                value="com"
                size="small"
                sx={{
                  bgcolor: '#fff',
                  width: { xs: '60px', md: '70px' },
                  borderRadius: 0,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent'
                  }
                }}
              >
                <MenuItem value="com">com</MenuItem>
              </Select>
              <Typography sx={{ 
                color: '#fff', 
                fontSize: { xs: '12px', md: '14px' },
                whiteSpace: 'nowrap',
                display: { xs: 'none', md: 'block' }
              }}>
                0,08 €* / pro Monat im 1. Jahr
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Main Content Section */}
      <Container maxWidth="xl" sx={{ pt: 4, pb: 6 }}>
        <Box sx={{ 
          display: 'flex',
          gap: { xs: 2, md: 4 },
          flexDirection: { xs: 'column', md: 'row' }
        }}>
          {/* Main Content */}
          <Box sx={{ flex: 1 }}>
            <Typography 
              variant="h1" 
              sx={{ 
                fontSize: { xs: '32px', md: '48px' },
                fontFamily: 'Inter, sans-serif',
                fontWeight: 800,
                mb: 3,
                color: '#000'
              }}
            >
              Frequently Asked Questions (FAQ) - Larrvarris
            </Typography>

            {/* Search Bar */}
            <Box sx={{ mb: 5 }}>
              <TextField
                fullWidth
                placeholder="How can we help you?"
                variant="outlined"
                InputProps={{
                  startAdornment: <SearchIcon sx={{ color: '#666', mr: 1 }} />,
                  sx: {
                    bgcolor: '#fff',
                    borderRadius: 0,
                    '& fieldset': {
                      borderColor: '#e0e0e0'
                    }
                  }
                }}
                sx={{ mb: 4 }}
              />
            </Box>

            {/* FAQ Categories */}
            {[
              {
                title: 'General Questions',
                questions: [
                  {
                    q: '1. What is Larrvarris?',
                    a: 'Larrvarris is a cutting-edge AI-powered platform designed to provide intelligent domain management, AI chat solutions, and advanced web services. Our goal is to simplify and enhance digital presence management through innovative AI technology.'
                  },
                  {
                    q: '2. How can I contact customer support?',
                    a: 'You can reach us via email at support@larrvarris.com, through our contact form on the website, or by phone at +1 (555) 123-4567. Our AI chat support is also available 24/7.'
                  },
                  {
                    q: '3. What are your working hours?',
                    a: 'Our human support team is available from 9:00 AM to 6:00 PM EST, Monday through Friday. However, our AI systems provide 24/7 assistance for most services.'
                  }
                ]
              },
              {
                title: 'Account & Services',
                questions: [
                  {
                    q: '4. How do I create an account?',
                    a: 'To create an account, click on the "Join now" button in the top navigation, provide your details, and follow the verification instructions. The process takes less than 2 minutes.'
                  },
                  {
                    q: '5. I forgot my password. How can I reset it?',
                    a: 'Click on the "Forgot Password" link on the login page, enter your registered email, and follow the reset instructions. Our AI system will ensure secure password recovery.'
                  },
                  {
                    q: '6. How do I update my profile information?',
                    a: 'Log in to your Larrvarris dashboard, click on your profile icon in the top right corner, select "Profile Settings," and update your information as needed.'
                  }
                ]
              },
              {
                title: 'Payments & Billing',
                questions: [
                  {
                    q: '7. What payment methods do you accept?',
                    a: 'We accept all major credit/debit cards (Visa, MasterCard, American Express), PayPal, bank transfers, and cryptocurrency (Bitcoin, Ethereum). All transactions are secured with enterprise-grade encryption.'
                  },
                  {
                    q: '8. Do you offer refunds?',
                    a: 'Yes, we offer a 30-day money-back guarantee for all our services. Please review our Refund Policy at larrvarris.com/refund-policy for detailed information.'
                  }
                ]
              },
              {
                title: 'Technical Support',
                questions: [
                  {
                    q: "9. I'm experiencing technical issues. What should I do?",
                    a: 'First, try our AI diagnostic tool at larrvarris.com/diagnostic. If issues persist, clear your browser cache or contact our technical support team at tech@larrvarris.com.'
                  },
                  {
                    q: '10. Is my personal information secure?',
                    a: 'Yes, we implement military-grade encryption (AES-256) and follow GDPR compliance standards. Your data is protected by advanced AI security systems and regular security audits. View our detailed security measures at larrvarris.com/security.'
                  }
                ]
              },
              {
                title: 'Other Questions',
                questions: [
                  {
                    q: '11. Do you offer discounts or promotions?',
                    a: 'Yes! Subscribe to our newsletter for exclusive deals. First-time users get a 20% discount, and we offer special enterprise pricing for bulk services. Check larrvarris.com/promotions for current offers.'
                  },
                  {
                    q: '12. Can I collaborate or partner with Larrvarris?',
                    a: 'We welcome partnerships! Contact our business development team at partners@larrvarris.com or visit larrvarris.com/partnerships to explore collaboration opportunities.'
                  }
                ]
              }
            ].map((category, idx) => (
              <Box key={idx} sx={{ mb: 6 }}>
                <Typography 
                  variant="h2" 
                  sx={{ 
                    fontSize: '24px',
                    fontWeight: 800,
                    mb: 3,
                    color: '#000'
                  }}
                >
                  {category.title}
                </Typography>
                <List sx={{ pl: 0 }}>
                  {category.questions.map((item, index) => (
                    <ListItem 
                      key={index}
                      sx={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        py: 2,
                        px: 3,
                        mb: 2,
                        bgcolor: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: 0,
                        '&:hover': {
                          borderColor: '#0066CC',
                          bgcolor: '#f8f9fa'
                        }
                      }}
                    >
                      <Typography 
                        sx={{ 
                          fontWeight: 700,
                          color: '#000',
                          mb: 1
                        }}
                      >
                        {item.q}
                      </Typography>
                      <Typography 
                        sx={{ 
                          color: '#444',
                          fontWeight: 500
                        }}
                      >
                        {item.a}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}

            <Typography 
              sx={{ 
                mt: 4, 
                color: '#666',
                fontWeight: 600
              }}
            >
              If you have any other questions, feel free to contact us at support@larrvarris.com or visit our Help Center!
            </Typography>
          </Box>

          {/* Table of Contents Sidebar */}
          <Box sx={{ 
            width: { md: '240px' },
            flexShrink: 0,
            position: { md: 'sticky' },
            top: 24,
            height: 'fit-content',
            bgcolor: '#fff',
            borderRadius: 0,
            border: '1px solid #e0e0e0',
            p: 3
          }}>
            <Typography 
              sx={{ 
                fontWeight: 800,
                mb: 2,
                color: '#000'
              }}
            >
              Table of content
            </Typography>
            <List sx={{ p: 0 }}>
              {[
                'General Questions',
                'Account & Services',
                'Payments & Billing',
                'Technical Support',
                'Other Questions'
              ].map((item, index) => (
                <ListItem 
                  key={index}
                  sx={{ 
                    p: 0,
                    mb: 1.5,
                    cursor: 'pointer',
                    fontWeight: 600,
                    '&:hover': {
                      color: '#0066CC'
                    }
                  }}
                >
                  <Typography 
                    sx={{ 
                      fontSize: '14px',
                      color: 'inherit',
                      fontWeight: 'inherit'
                    }}
                  >
                    {item}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FAQ; 